var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubstagehowered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 15 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: url(#linear-gradient);\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 7,
    x2: 15,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3aecfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465ee9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.39,2.53h6.22M4.16,4.33l3.56,5.36M1.74,4.56h1.4c.44,0,.65,0,.82-.09.15-.08.27-.2.34-.36.08-.17.08-.4.08-.86v-1.46c0-.46,0-.68-.08-.86-.07-.15-.19-.28-.34-.36-.17-.09-.38-.09-.82-.09h-1.4c-.44,0-.65,0-.82.09-.15.08-.27.2-.34.36-.08.17-.08.4-.08.86v1.46c0,.46,0,.68.08.86.07.15.19.28.34.36.17.09.38.09.82.09ZM8.74,13.5h1.4c.44,0,.65,0,.82-.09.15-.08.27-.2.34-.35.08-.17.08-.4.08-.86v-1.46c0-.46,0-.68-.08-.86-.07-.15-.19-.28-.34-.35-.17-.09-.38-.09-.82-.09h-1.4c-.44,0-.65,0-.82.09-.15.08-.27.2-.34.35-.08.17-.08.4-.08.86v1.46c0,.46,0,.68.08.86.07.15.19.28.34.35.17.09.38.09.82.09ZM11.86,4.56h1.4c.44,0,.65,0,.82-.09.15-.08.27-.2.34-.36.08-.17.08-.4.08-.86v-1.46c0-.46,0-.68-.08-.86-.07-.15-.19-.28-.34-.36-.17-.09-.38-.09-.82-.09h-1.4c-.44,0-.65,0-.82.09-.15.08-.27.2-.34.36-.08.17-.08.4-.08.86v1.46c0,.46,0,.68.08.86.07.15.19.28.34.36.17.09.38.09.82.09Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubstagehowered);
export default __webpack_public_path__ + "static/media/Substage howered.9d2a411cd4db38abfeedab0977b6c9b7.svg";
export { ForwardRef as ReactComponent };